<template>
    <div class="footer-complex">
        <div class="left">
            <div class="nav">
                <span>首页</span>
                <span>作答中心</span>
            </div>
            <div class="hr"></div>
            <div class="info">
                <span>© 京ICP备18010967号</span>
                <span>北京易数模法科技有限公司 版权所有</span>
            </div>
        </div>
        <div class="right">
            <img src=""/>
        </div>
    </div>
</template>

<style scoped>
.footer-complex{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    background: #666666;
    font-size: 14px;
    color: #D7D7D7;
}
.left{
    display: flex;
    flex-direction: column;
    margin-top: .46rem;
}
.nav{
    display: flex;
    flex-direction: row;
    
}
</style>

<script>
export default {
    props: {
        footer: Object
    }
}
</script>


// WEBPACK FOOTER //
// src/templates/footer/complex.vue